export default __webpack_public_path__ + "static/media/settings_user_permission_img.0672f7a6.svg";